<template>
<div class="chapter">
<div class="inner_page">
<hr/>
<p class="left">A Harvest Original •</p>
<p class="left"><span style="font-size: smaller">HARCOURT, INC.</span></p>
<p class="follow"><em>Orlando</em></p>
<p class="follow"><em>Austin</em></p>
<p class="follow"><em>New York</em></p>
<p class="follow"><em>San Diego</em></p>
<p class="follow"><em>Toronto</em></p>
<p class="follow"><em>London</em></p>
<hr/>
<p class="left">Copyright © 2006 by Charles Yu</p><p class="follow"><a id="piv"></a></p>
<p class="left">All rights reserved. No part of this publication may be reproduced or<br/>
transmitted in any form or by any means, electronic or mechanical,<br/>
including photocopy, recording, or any information storage and<br/>
retrieval system, without permission in writing from the publisher.</p>
<p class="left">Requests for permission to make copies of any part of the work<br/>
should be submitted online at <a href="http://www.harcourt.com/contact" target="_blank">www.harcourt.com/contact</a> or mailed<br/>
to the following address: Permissions Department, Harcourt, Inc.,<br/>
6277 Sea Harbor Drive, Orlando, Florida 32887-6777.</p>
<p class="left"><a href="http://www.HarcourtBooks.com" target="_blank">www.HarcourtBooks.com</a></p>
<p class="left">Earlier versions of the following stories appeared in the following<br/>
magazines: "32.05864991%," <em>The Malahat Review;</em> 'Autobiographical Raw<br/>
Material Unsuitable for the Mining of Fiction," <em>Alaska Quarterly Review;</em><br/>
"Third Class Superhero" appeared as "Class Three Superhero,"<br/>
<em>Mid-American Review;</em> "Florence," <em>Eclectica;</em> "My Last Days As Me,"<br/>
<em>Sou'wester,</em> reprinted in the <em>Robert Olen Butler Prize Stories 2004;</em> "Problems<br/>
for Self-Study," <em>Harvard Review;</em> "Realism," <em>Mississippi Review;</em> "The Man Who<br/>
Became Himself," <em>The Gettysburg Review;</em> "Two-Player Infinitely Iterated<br/>
Simultaneous Semi-Cooperative Game with Spite and Reputation," <em>Eclectica.</em></p>
<p class="left">Library of Congress Cataloging-in-Publication Data<br/>
Yu, Charles, 1976–<br/>
Third class superhero/Charles Yu.—1st ed.<br/>
p. cm.<br/>
"A Harvest original."<br/>
I. Title.<br/>
PS3625.U15T48 2006<br/>
813'.6—dc22 2006004786<br/>
ISBN-13: 978-0-15-603081-6 ISBN-10: 0-15-603081-0</p>
<p class="left">Text set in Mrs. Eaves Roman<br/>
Designed by Scott Piehl</p>
<p class="left">Printed in the United States of America</p>
<p class="left">First edition</p>
<p class="left"><span style="font-size: smaller">A B C D E F G H I J K</span></p>
<hr/>
<blockquote>
<p class="left">for my parents</p><p class="follow"><a id="pv"></a></p>
</blockquote>
<hr/>
<h1 class="fronttitle">Contents</h1>
<p class="left"><b>Story 1</b> 1 Third Class Superhero</p><p class="follow"><a id="pvii"></a></p>
<p class="left"><b>Story 2</b> 25 401(k)</p>
<p class="left"><b>Story 3</b> 37 The Man Who Became Himself</p>
<p class="left"><b>Story 4</b> 55 Problems for Self-Study</p>
<p class="left"><b>Story 5</b> 67 My Last Days As Me</p>
<p class="left"><b>Story 6</b> 89 Two-Player Infinitely Iterated Simultaneous Semi-Cooperative Game with Spite and Reputation</p>
<p class="left"><b>Story 7</b> 99 Realism</p>
<p class="left"><b>Story 8</b> 111 Florence</p>
<p class="left"><b>Story 9</b> 131 Man of Quiet Desperation Goes on Short Vacation</p>
<p class="left"><b>Story 10</b> 143 32.05864991%</p>
<p class="left"><b>Story 11</b> l6l Autobiographical Raw Material Unsuitable for the Mining of Fiction</p>
<p class="left"><b>Acknowledgments</b> 175</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front.vue?a67725fc